export const dataTable = {
  columns: [
    {
      label: "Punto de Referencia",
      field: "name",
    },
    
    {
      label: "Opciones",
      field: "options",
    },
  ],
  rows: [ ],
}
